import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import CustomInput from "../../components/CustomInput";
import { deepClone, toCamelCase } from "../../helpers/objectHelper";
import { runInAction, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { invoiceFieldValidator, hasOrgNoValidation } from "../../helpers/inputValidator.helper";
import Axios from "axios";
import { Button } from "reactstrap";
import { GLNPopup } from "../../components/GLNPopup";
import { isValid, getFieldValue, isGovernment, convertAutocomplete } from "./InvoiceFieldHelpers"; //unpush, glnSuccess,
import EventLabel, { GetEventLabelValueFn } from "../../components/EventLabel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const InvoiceFieldsNew = observer((props) => {
  const {
    activePersonNo,
    orders,
    updateOrder,
    environment,
    settings,
    currentType,
    selectedCountry,
    selectedOption,
    checkHeights,
    invoiceAnchor,
    mainEvent,
    validatePaymentFields,
    eventLabels,
    validations,
    validate,
    updateEventLabels,
  } = props;

  const [showGLNWindow, setShowGLNWindow] = useState(false);
  const [glnOrgFields, setGlnOrgFields] = useState([]);
  const [invoiceFields, setInvoiceFields] = useState([]);
  const initialRegex = /^[a-zA-Z0-9\-\s]{1,25}$/;
  const [currentRegex, setCurrentRegex] = useState(initialRegex);
  const [currentInfo, setCurrentInfo] = useState(null);
  const [GLNList, setGLNList] = useState([]);
  const [validFields, setValidFields] = useState(false);
  const paymentType = currentType;
  const [lastValidVatNo, setLastValidVatNo] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [refNoWarning, setRefNoWarning] = useState(false);
  const [currentLeaderNo, setCurrentLeaderNo] = useState(activePersonNo);
  const [lockGLN, setLockGLN] = useState(true);
  const [applySweVat, setApplySweVat] = useState(false);
  const [applyEuVat, setApplyEuVat] = useState(false);
  const [vatNoStatus, setVatNoStatus] = useState(false);
  const [timerExpired, setTimerExpires] = useState(false);
  const [orgNoValid, setOrgNoValid] = useState(null);
  const [showVatField,setShowVatField] = useState(false);

  const orgNoRef = useRef("");
  const glnFieldPlaceholder = useMemo(() => GetEventLabelValueFn({ name: "GLNPlaceholder", groupName: "CMS.Payment" }, eventLabels, environment, updateEventLabels), [eventLabels]);

  useEffect(() => {
    checkHeights();
    finalValid();
  }, [validations, validations?.length, selectedOption, currentType, selectedCountry, validatePaymentFields]);

  useEffect(() => {
    var fono = 0;
    let o = orders[currentLeaderNo]?.invoice?.orgNo;
    if (o && o.length > 1) {
      fono = o.substring(0, 2);
    }
    if (currentType != "person" && settings.swevat && selectedCountry.swedishCountry && (fono == 20 || fono == 21 || fono == 23) && validations.find((v) => v.id == "INVOICE_OrgNo")?.valid) {
      //we know we're a swedish country, and that the settings is active, and that we're an applicable type.
      setApplySweVat(true);
      if (orders[currentLeaderNo]?.orderExtra && orders[currentLeaderNo]?.orderExtra?.length == 0) {
        applyVat();
      }
    } else {
      setApplySweVat(false);
    }
    if (!validations.find((v) => v.id == "INVOICE_OrgNo")?.valid && orders[currentLeaderNo]?.invoice?.orgNo && orgNoRef.current != orders[currentLeaderNo]?.invoice?.orgNo) {
      orgNoRef.current = orders[currentLeaderNo].invoice.orgNo;
      handleValueChange(orders[currentLeaderNo].invoice.orgNo, "orgNo");
    }
  }, [orders, validations, currentLeaderNo]);

  useEffect(() => {
    if (glnOrgFields.length > 1) {
      checkHeights();
      setTimeout(scrollToAnchor, 500);
    }
  }, [invoiceFields.length, glnOrgFields.length]);

  const scrollToAnchor = () => {
    invoiceAnchor.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  };

  useEffect(() => {
    let current = orders.filter((a) => a.leader)[0];
    let index = -1;
    if (current) {
      index = orders.indexOf(current);
    }
    if (index != -1) {
      setCurrentLeaderNo(index);
    } else {
      setCurrentLeaderNo(activePersonNo);
      if (!validations.find((v) => v.label == "PaymentOption").valid) {
        finalValid();
      }
    }
  });

  useEffect(() => {
    if (timerExpired) {
      handleValueChange(orders[currentLeaderNo].invoice.name, "Name");
      setTimerExpires(false);
    }
  }, [timerExpired]);

  const applyVat = () => {
    if (orders.length == 0) {
      return;
    }
    var newOrder = deepClone(orders[currentLeaderNo]);
    var type = newOrder["orderExtra"];
    var newType = undefined;
    if (!type) {
      newType = [];
    } else {
      newType = deepClone(type);
    }

    if (applySweVat || applyEuVat) {
      let vatno = newOrder["invoice"]?.vatNo;
      newType = vatno
        ? [
            { name: "vatExempt", value: true, value2: "" },
            { name: "vatNo", value: vatno, value2: "" },
          ]
        : [
            { name: "vatExempt", value: true, value2: "" },
            { name: "sweVat", value: true, value2: ""},
          ];
      newOrder["orderExtra"] = newType;
      runInAction(() => {
        updateOrder(newOrder, currentLeaderNo);
      });
    } else {
      newType = [];
      newOrder["orderExtra"] = newType;
      runInAction(() => {
        updateOrder(newOrder, currentLeaderNo);
      });
    }
  };

  useEffect(() => {
    applyVat();
  }, [applySweVat, applyEuVat]);

  useEffect(() => {
    if(props.breakouts && props.contentLayout){
      const layoutIds = props.contentLayout.contentLayoutModules.filter(x => x.contentModule.type=="EVENT").map(x => x.contentModule.settings.eventId)
      const breakouts = props.breakouts.filter(x => layoutIds.includes(x.eventId));
      console.log(breakouts.some(x => x.allowReverseCharge))
      setShowVatField(breakouts.some(x => x.allowReverseCharge));
    }
  },[props.breakouts,props.contentLayout]);

  //when it's loaded
  useEffect(() => {
    if (selectedOption != "" && currentType != "") {
      //find if we're comgov/pers here, and then display the correct fields
      if (selectedOption != "dibs" && selectedOption != "stripe") {
        setLastValidVatNo("");
        setVatNoStatus("");
        let f = [];
        if (currentType == "person") {
          f = ["Name", "Address1", "Address2", "Zip", "City", "Email"];
          setInvoiceFields(f);
          setGlnOrgFields([]);
          runInAction(() => {
            validations.find((v) => v.id == "INVOICE_Telephone1").valid = true;
            validations.find((v) => v.id == "INVOICE_OrgNo").valid = true;
          });
          checkHeights();
        } else {
          orgNoRef.current = "";
          var shouldValidateOrgNo = hasOrgNoValidation(selectedCountry?.countryCode);
          if (!glnOrgFields.includes("GLN")) {
            setGlnOrgFields(["OrgNo"]);
          }
          if (invoiceFields.length > 0 && shouldValidateOrgNo) {
            setInvoiceFields([]);
          }
          if (!shouldValidateOrgNo) {
            var newFields = ["Name", "Telephone1", "Address1", "Address2", "Zip", "City", "Email"];
            if (showVatField && europeVAT()) {
              newFields.push("vatNo");
            }
            setInvoiceFields(newFields);
          }
          if (orders[currentLeaderNo]?.invoice?.orgNo && orders[currentLeaderNo].invoice.orgNo.length > 0) {
            handleValueChange(orders[currentLeaderNo].invoice.orgNo, "OrgNo");
          }
        }
      } else {
        setGlnOrgFields([]);
        setInvoiceFields([]);
        setLastValidVatNo("");
        setVatNoStatus("");
      }

      checkHeights();

      const tempOrders = deepClone(orders[currentLeaderNo]);

      runInAction(() => {
        updateOrder(tempOrders, currentLeaderNo);
      });
    }
  }, [selectedOption, currentType, selectedCountry, showVatField]);

  useEffect(() => {
    var currentVatNo = getFieldValue("vatNo", orders, currentLeaderNo);
    if (currentVatNo == lastValidVatNo && lastValidVatNo != "") {
      if (mainEvent.allowReverseCharge || true) {
        setApplyEuVat(true);
        setVatNoStatus("ok");
      }
    } else if (currentVatNo != lastValidVatNo && lastValidVatNo != "" && currentVatNo.length > 0) {
      setApplyEuVat(false);
      setVatNoStatus("error");
    } else {
      setApplyEuVat(false);
      setVatNoStatus("");
    }
  }, [lastValidVatNo, orders]);

  const loadVatNo = (no) => {
    let key = "26e46901d1bb903a5b69fc1eba05046f";
    var lastValid = "!";

    Axios.get(`https://euvatapi.com/api/v1/validate?access_key=${key}&vat_number=${no}`)
      .then((res) => {
        if ((res.status = 200)) {
          if (res.data.valid) {
            setLastValidVatNo(no);
            return;
          } else {
            console.error("VAT failed validation");
          }
        } else {
          console.error("VAT failed validation");
        }
      })
      .catch((err) => {
        console.error(err);
      });
    setLastValidVatNo(lastValid);
  };

  const finalValid = () => {
    runInAction(() => {
      let filteredValidations = validations.filter((v) => !String(v.id).includes("Telephone1"));
      if (currentType != "person") {
        filteredValidations = validations;
      }
      let fails = filteredValidations.filter((v) => v.valid == false && String(v.id).includes("INVOICE_"));
      filteredValidations.find((v) => v.label == "PaymentOption").valid = fails.length == 0 || selectedOption == "dibs" || selectedOption === "stripe" ? true : false;
    });
    if (selectedOption != "") {
      var order = orders[currentLeaderNo];
      var newOrder = deepClone(order);
      var type = newOrder["invoice"];
      var newType = undefined;
      if (!type) {
        newType = {};
      } else {
        newType = deepClone(type);
      }
      var p = true;
      if (selectedOption == "dibs") {
        newType = {};
        p = true;
      } else if (selectedOption === "stripe") {
        newType = {};
        p = true;
      } else if (selectedOption == "invoice" && validFields) {
        let em = newType["email"] == undefined ? "" : newType["email"];
        if (invoiceFieldValidator(em, "Email")) {
          newType["inExchangeRecipentId"] = "";
        }
        p = true;
      }
      if (p) {
        runInAction(() => {
          let filteredValidations = validations.filter((v) => !String(v.id).includes("Telephone1"));
          if (currentType != "person") {
            filteredValidations = validations;
          }
          let fails = filteredValidations.filter((v) => v.valid == false && String(v.id).includes("INVOICE_"));
          let willBeValid = fails == 0;

          if (currentType != "person") {
            if ((!orders[currentLeaderNo]?.invoice?.orgNo || orders[currentLeaderNo]?.invoice?.orgNo.length < 1) && ognRequired("OrgNo")) {
              filteredValidations.find((v) => v.id == "INVOICE_OrgNo").valid = false;
              willBeValid = false;
            } else {
              filteredValidations.find((v) => v.id == "INVOICE_OrgNo").valid = true;
            }
          }

          if (willBeValid && !order.isActive) orders[currentLeaderNo].isActive = "temp";
          filteredValidations.find((v) => v.label == "PaymentOption").valid = willBeValid || selectedOption == "dibs" || selectedOption === "stripe" ? true : false;
        });
      }
    }
  };

  //final validation
  useEffect(() => {
    finalValid();
  }, [selectedOption, paymentType, orders, validFields, showGLNWindow]);

  // This component has grown to complex, because of the many different states and effects that are needed to make it work.
  // I can not understand why this component is so complex, and I think it should be refactored to be more simple.
  // This effect checks if the orgnNo is valid based on if there is fields generated based on the input, if valid there will be invoice fields.
  // This is a work around and it is not a good solution.
  useEffect(() => {
    if (hasOrgNoValidation(selectedCountry.countryCode) && orgNoRef?.current?.length >= 4 && invoiceFields.length === 0) {
      setOrgNoValid(false);
    } else setOrgNoValid(true);
  }, [ognRequired, orgNoRef, selectedCountry, invoiceFields]);

  const handleValueChange = (v, t) => {
    let order = orders[currentLeaderNo];
    let newOrder = deepClone(order);
    let type = newOrder["invoice"];
    let newType = undefined;
    let value = v;

    if (!type) {
      newType = {};
    } else {
      newType = deepClone(type);
    }

    if (t === "OrgNo") {
      value = value.replace(/[^0-9.]/g, "");
    }

    let isValid = invoiceFieldValidator(value, t, selectedCountry.countryCode, t == "Telephone1" ? currentRegex : "", currentType);

    if (!newType["countryId"]) {
      newType["countryId"] = selectedCountry.value;
    }

    if (t == "OrgNo" && isValid && currentType != "person") {
      if (orgNoRef.current != value) {
        if (orgNoRef.current != "" && hasOrgNoValidation(selectedCountry.countryCode)) {
          newType = {};
        }
      }
      orgNoRef.current = value;
    }

    if (t == "OrgNo" && isValid && currentType != "person") {
      let d = "";
      if (settings.paymentGrid[selectedCountry?.name?.toLowerCase()] != undefined) {
        d = settings.paymentGrid[selectedCountry.name.toLowerCase()];
      } else {
        d = settings.paymentGrid["global"];
      }
      if (!glnOrgFields.includes("GLN")) {
        let fieldsToAdd = ["OrgNo"];
        if (selectedCountry.swedishCountry) {
          fieldsToAdd.push("GLN");
        }

        setGlnOrgFields(fieldsToAdd);
      }
      if (hasOrgNoValidation(selectedCountry.countryCode)) {
        Axios.get(`./api/invoice/testexchange/${value}?eventId=${environment.eventId}`)
          .then((res) => {
            if ((res.status = 200)) {
              if (res.data.parties.length > 0) {
                if (res.data.parties.length > 1) {
                  setLockGLN(true);
                  var cGLN = orders[currentLeaderNo]?.invoice?.gLN;
                  if (!cGLN) {
                    cGLN = orders[currentLeaderNo]?.invoice?.gln;
                  }
                  if (cGLN) {
                    let r = res.data.parties.find((a) => a.gln == cGLN);
                    setGLNList([r]);
                    onSuccess(r);
                  } else {
                    setGLNList(res.data.parties.sort((a, b) => a.name > b.name && (1 || -1)));
                  }
                } else {
                  setGLNList([res.data.parties[0]]);
                  setLockGLN(true);
                  onSuccess(res.data.parties[0]);
                }
              } else {
                setGLNList([]);
                onSuccess(null);
                setLockGLN(false);
              }
            }
          })
          .catch((err) => {
            setLockGLN(false);
            console.error(err);
          });

        let on = value.replace("-", "").replace(" ", "");
        Axios.get(`./api/invoice/GetOrgRegex/${on.slice(0, 6) + "-" + on.slice(6)}`)
          .then((res) => {
            if ((res.status = 200)) {
              if (res.data) {
                setCurrentRegex(RegExp(res.data));
              } else {
                setCurrentRegex(initialRegex);
              }
            }
          })
          .catch((err) => {
            console.error(err);
            setCurrentRegex(initialRegex);
          });

        Axios.get(`./api/invoice/GetOrgInfo/${on.slice(0, 6) + "-" + on.slice(6)}`)
          .then((res) => {
            if ((res.status = 200)) {
              if (res.data) {
                setCurrentInfo(res.data);
              } else {
                setCurrentInfo(null);
              }
            }
          })
          .catch((err) => {
            console.error(err);
            setCurrentInfo(null);
          });
      } else {
        if (invoiceFields.length < 3) {
          setGLNList([]);
          setLockGLN(false);
          onSuccess(null);
        }
      }
    } else if (t == "OrgNo" && !isValid && currentType != "person") {
      if (glnOrgFields.includes("GLN")) {
        setGlnOrgFields(["OrgNo"]);
      }
      var shouldValidateOrgNo = hasOrgNoValidation(selectedCountry?.countryCode);
      if (shouldValidateOrgNo) {
        setInvoiceFields([]);
      }
      newType = {};
    }

    newType[toCamelCase(t)] = value;
    newOrder["invoice"] = newType;
    updateOrder(newOrder, currentLeaderNo);

    runInAction(() => {
      var tempV = validations.find((v) => v.id == "INVOICE_" + t);
      if (tempV) {
        tempV.valid = isValid;
      }

      let filteredValidations = validations.filter((v) => !String(v.id).includes("Telephone1"));
      if (currentType != "person") {
        filteredValidations = validations;
      }
      let fails = filteredValidations.filter((v) => v.valid == false && String(v.id).includes("INVOICE_") && !String(v.id).includes(t));
      fails = fails + (isValid ? 0 : 1);
      filteredValidations.find((v) => v.label == "PaymentOption").valid = fails == 0 || selectedOption == "dibs" || selectedOption === "stripe" ? true : false;
    });

    if (isValid) {
      //full validation
      var allAreValid = true;
      let toValidate = validations.filter((v) => v.id.toString().includes("INVOICE_"));
      for (let i = 0; i < toValidate.length; i++) {
        let tar = toValidate[i].id.split("_")[1];
        let val = newType[toCamelCase(tar)];
        let v = invoiceFieldValidator(val == undefined ? "" : val, tar, selectedCountry.countryCode, tar == "Telephone1" ? currentRegex : "", currentType);
        if (!v) {
          if (currentType == "person" && (tar == "Telephone1" || tar == "OrgNo")) {
            //currently this validates ALL REF NOs but we still warn if incorrect
            v = true;
          } else if ((tar == "Email" && newType["electronicInvoice"]) || newType["inExchangeRecipentId"]?.length > 0) {
            v = true;
          } else if (tar == "GLN") {
            if (selectedCountry.countryCode != "SWE" || GLNList.length == 0) {
              v = true;
            }
          } else if (tar == "GLN" && paymentType == "person") {
            v = true;
          } else if (tar == "Address2" || tar == "Address1") {
            v = true;
          } else if (tar == "CountryCode" && paymentType == "person") {
            v = true;
          }
          if (!v) {
            allAreValid = false;
          }
        }
        runInAction(() => {
          toValidate[i].valid = v;
        });
      }
      setValidFields(allAreValid);
      if (allAreValid) {
        finalValid();
      }
    }
  };

  //selected a GLN number
  const onSuccess = (obj) => {
    setShowGLNWindow(false);
    if (obj == -1) {
      return;
    }

    let f = ["Name", "Telephone1", "Address1", "Address2", "Zip", "City"]; //,"InExchangeRecipentId","ElectronicInvoice"

    let cc = obj ? (obj.countryCode == "SE" ? "SWE" : obj.countryCode) : selectedCountry.countryCode;
    if (obj != null && cc == selectedCountry.countryCode) {
      let order = orders[currentLeaderNo];
      let newOrder = deepClone(order);
      let type = newOrder["invoice"];
      let newType = undefined;

      if (!type) {
        newType = {};
      } else {
        newType = deepClone(type);
      }
      newType[toCamelCase("InExchangeRecipentId")] = obj.companyId;
      newType[toCamelCase("vatNo")] = obj.vatNo;
      newType[toCamelCase("ElectronicInvoice")] = obj.receiveElectronicInvoiceCapability == "ReceivingElectronicInvoices" ? true : false;
      newType[toCamelCase("Address1")] = obj.streetName;
      newType[toCamelCase("Zip")] = obj.postalZone;
      newType[toCamelCase("City")] = obj.city;
      newType[toCamelCase("Name")] = obj.name;
      newType[toCamelCase("GLN")] = obj.gln;
      newType[toCamelCase("Telephone1")] = newType["telephone1"] ? newType["telephone1"] : "";
      newType[toCamelCase("CountryId")] = selectedCountry.value; // obj.countryCode == "SE" ? "SWE" : obj.countryCode;
      newType[toCamelCase("Email")] = newType[toCamelCase("ElectronicInvoice")] ? "" : obj.email;

      if (obj.receiveElectronicInvoiceCapability != "ReceivingElectronicInvoices") {
        f.push("Email");
      }

      newOrder["invoice"] = newType;
      runInAction(() => {
        updateOrder(newOrder, currentLeaderNo);
      });
    } else {
      checkHeights();
      setGlnOrgFields(["OrgNo"]);
      f.push("Email");
      runInAction(() => {
        updateOrder(orders[currentLeaderNo], currentLeaderNo);
      });
    }
    if (showVatField && europeVAT()) {
      f.push("vatNo");
    }
    setInvoiceFields(f);
    scrollToAnchor();

    setTimeout(() => {
      finalValid();
      setTimerExpires(true);
    }, 500);
  };

  const toggleWindow = () => {
    setShowGLNWindow(!showGLNWindow);
  };

  const ivfRequired = (di) => {
    if (di == "vatNo") {
      return !applyEuVat;
    }
    if (di == "Address1") {
      return false;
    } else if (di == "OrgNo" && paymentType == "person") {
      //SSN check here
      return isValid(di, getFieldValue(di, orders, currentLeaderNo), selectedCountry.countryCode, di == "Telephone1" ? currentRegex : "", currentType);
    } else if (di == "Telephone1") {
      if (getFieldValue(di, orders, currentLeaderNo).length > 0 && currentRegex) {
        return !currentRegex.test(String(getFieldValue(di, orders, currentLeaderNo)));
      } else {
        return false;
      }
    } else {
      return isValid(di, getFieldValue(di, orders, currentLeaderNo), selectedCountry.countryCode, di == "Telephone1" ? currentRegex : "", currentType);
    }
  };

  const ognRequired = (di) => {
    if (selectedCountry?.countryCode?.toUpperCase() !== "SWE" || selectedCountry?.countryCode?.toUpperCase() !== "NOR") {
      return false;
    }

    if (di == "GLN" && GLNList.length == 0) {
      return false;
    } else if (di == "OrgNo" && paymentType == "comgov") {
      let c = isGovernment(getFieldValue(di, orders, currentLeaderNo), selectedCountry.countryCode) ? "government" : "company";
      c = "comgov";
      let d = "";
      if (settings.paymentGrid[selectedCountry?.name?.toLowerCase()] != undefined) {
        d = settings.paymentGrid[selectedCountry?.name?.toLowerCase()];
      } else {
        d = settings.paymentGrid["global"];
      }
      if (!d.includes(c)) {
        return true;
      } else {
        return isValid(di, getFieldValue(di, orders, currentLeaderNo), selectedCountry.countryCode, null, currentType);
      }
    } else {
      return isValid(di, getFieldValue(di, orders, currentLeaderNo), selectedCountry.countryCode, null, currentType);
    }
  };

  const onEmail = () => {
    let b = !showEmail;
    setShowEmail(b);

    let f = [...invoiceFields];

    if (b) {
      if (!invoiceFields.includes("Email")) {
        f.push("Email");
      }
    } else {
      if (invoiceFields.includes("Email")) {
        f.splice(f.indexOf("Email"), 1);
        handleValueChange("", "Email");
      }
    }
    if (f.includes("vatNo")) {
      f.splice(f.indexOf("vatNo"), 1);
      f.push("vatNo");
    }

    setInvoiceFields(f);
  };

  const emailBool = () => {
    let b = true;
    if (
      invoiceFields.length < 1 ||
      selectedOption == "" ||
      (paymentType == "person" && selectedOption == "dibs") ||
      (paymentType == "person" && selectedOption == "stripe") ||
      (paymentType == "person" && selectedOption == "invoice") ||
      isGovernment(getFieldValue("orgNo", orders, currentLeaderNo), selectedCountry.countryCode) ||
      ((paymentType == "comgov" || paymentType == "company") && GLNList.length == 0) ||
      (getFieldValue("electronicInvoice", orders, currentLeaderNo), selectedCountry.countryCode)
    ) {
      b = false;
    }
    return b;
  };

  const vatNoBlur = (e) => {};

  const refNoBlur = (e) => {
    if (ivfRequired("Telephone1") && String(currentRegex) != String(initialRegex)) {
      setRefNoWarning(true);
    } else {
      setRefNoWarning(false);
    }
  };

  const refNoFocus = (e) => {
    checkHeights();
    setRefNoWarning(false);
  };

  const infoPaneIsLink = (info) => {
    const l = info.toLowerCase();
    if (info && (l.startsWith("http") || l.startsWith("www") || l.endsWith(".com") || l.endsWith(".net") || l.endsWith(".se"))) {
      return true;
    }
    return false;
  };

  const europeVAT = () => {
    const eventCountry = environment.eventCountry;
    return selectedCountry && selectedCountry?.europeCountry && eventCountry?.europeCountry && (selectedCountry.value !=eventCountry?.countryId)
  }

  const validateVatNo = () => loadVatNo(getFieldValue("vatNo", orders, currentLeaderNo));

  const runtimeValidation = useCallback(
    (type) => {
      const valitypety = validations.find((v) => v.id == `INVOICE_${type}`);
      if (validate && valitypety?.valid === false) {
        return false;
      }
      if (valitypety?.valid === false && getFieldValue(type, orders, currentLeaderNo)?.length > 0) {
        return false;
      }
      return undefined;
    },
    [currentLeaderNo, orders, validate, getFieldValue, validations]
  );

  const validatedInvoiceFields = useMemo(() => (invoiceFields ?? [])?.map((type) => ({ type, valid: runtimeValidation(type) })), [invoiceFields, runtimeValidation]);
  const validatedglnOrgFields = useMemo(() => (glnOrgFields ?? [])?.map((type) => ({ type, valid: runtimeValidation(type) })), [glnOrgFields, runtimeValidation]);

  if (settings.hidden) {
    return null;
  } else {
    return (
      <>
        {validatedglnOrgFields.length > 0
          ? validatedglnOrgFields.map(({ type, valid }) => {
              return (
                <React.Fragment key={type}>
                  {showGLNWindow && type == "GLN" ? <GLNPopup onSuccess={onSuccess} list={GLNList} /> : null}
                  <CustomInput
                    required={ognRequired(type)}
                    prefixClassName={"cms-field invoice" + (type == "GLN" && GLNList.length > 1 ? " pointer" : "")}
                    value={getFieldValue(type, orders, currentLeaderNo)}
                    readonly={type == "GLN" ? lockGLN : false}
                    onChange={(val) => (type == "CountryCode" ? handleValueChange(val, type) : handleValueChange(val?.target?.value ?? val, type))}
                    label={type}
                    valid={valid}
                    staticLabel={true}
                    type={type}
                    invoice={true}
                    lang={environment.lang}
                    eventId={environment.eventId}
                    onClick={type == "GLN" && GLNList.length > 1 ? toggleWindow : undefined}
                    placeholder={type == "GLN" && GLNList.length > 1 ? glnFieldPlaceholder : undefined}
                    autocomplete={convertAutocomplete(type)}
                  />
                  {type == "OrgNo" && !ognRequired("OrgNo") && currentInfo ? (
                    <span className="org-info-pane">
                      {infoPaneIsLink(currentInfo) ? (
                        <a href={currentInfo} target="_blank" rel="noreferrer">
                          {currentInfo}
                        </a>
                      ) : (
                        <span>{currentInfo}</span>
                      )}
                    </span>
                  ) : null}
                  {type == "OrgNo" && orgNoValid === false ? (
                    <span style={{ color: "red" }}>
                      <EventLabel name="OrgNoNotValid" groupName={"CMS.Payment"} />
                    </span>
                  ) : null}
                </React.Fragment>
              );
            })
          : null}
        {(validatedInvoiceFields.length > 0 && selectedOption == "invoice") || (selectedOption == "typebs" && showVatField)
          ? validatedInvoiceFields.map(({ type, valid }) => {
              return (
                <React.Fragment key={type}>
                  <CustomInput
                    required={ivfRequired(type) || type == "Telephone1"}
                    prefixClassName={"cms-field invoice"}
                    value={getFieldValue(type, orders, currentLeaderNo)}
                    readonly={type == "vatNo" && applyEuVat}
                    onChange={(val) => (type == "CountryCode" ? handleValueChange(val, type) : handleValueChange(val?.target?.value ?? val, type))}
                    label={type == "OrgNo" && paymentType == "person" ? "SSN" : type == "Name" && paymentType == "person" ? "PersonName" : type}
                    staticLabel={true}
                    type={type}
                    valid={valid}
                    invoice={true}
                    lang={environment.lang}
                    eventId={environment.eventId}
                    noLabel={type == "InExchangeRecipentId" || type == "ElectronicInvoice" || (type == "vatNo" && !showVatField) ? true : false}
                    noInputField={type == "InExchangeRecipentId" || type == "ElectronicInvoice" || (type == "vatNo" && !showVatField) ? true : false}
                    onBlur={type == "vatNo" ? vatNoBlur : type == "Telephone1" ? refNoBlur : null}
                    onFocus={type == "Telephone1" ? refNoFocus : null}
                    autocomplete={convertAutocomplete(type)}
                    appendButton={
                      type == "vatNo" && showVatField ? (
                        vatNoStatus == "ok" ? (
                          <CheckCircleIcon style={{ color: "var(--payment-button-border-color-active)" }} />
                        ) : (
                          <button className="cms-button append-button" onClick={validateVatNo}>
                            <EventLabel name="ValidateVatNo" groupName={"CMS.Payment"} />
                          </button>
                        )
                      ) : null
                    }
                  />
                  {type == "Telephone1" && refNoWarning && getFieldValue(type, orders, currentLeaderNo).length > 0 ? (
                    <div style={{ marginLeft: "1rem" }}>
                      <EventLabel name="RefNoWarning" groupName={"CMS.Payment"} />
                    </div>
                  ) : null}
                </React.Fragment>
              );
            })
          : null}
        {selectedOption == "dibs" ? <EventLabel name={"GoToDibs"} groupName={"CMS.Payment"} /> : null}
        {selectedOption == "stripe" ? <EventLabel name={"GoToStripe"} groupName={"CMS.Payment"} /> : null}
        {showVatField && europeVAT() && (selectedOption == "dibs" || selectedOption == "stripe") ?
          <>
            <CustomInput
              required={false}
              prefixClassName={"cms-field invoice"}
              value={getFieldValue("vatNo", orders, currentLeaderNo)}
              readonly={applyEuVat}
              onChange={(val) => (handleValueChange(val?.target?.value ?? val, "vatNo"))}
              label={"vatNo"}
              staticLabel={true}
              type={"vatNo"}
              //valid={valid}
              invoice={true}
              lang={environment.lang}
              eventId={environment.eventId}
              noLabel={!showVatField}
              noInputField={!showVatField}
              onBlur={vatNoBlur}
              appendButton={showVatField ? (
                  vatNoStatus == "ok" ? (
                    <CheckCircleIcon style={{ color: "var(--payment-button-border-color-active)" }} />
                  ) : (
                    <button className="cms-button append-button" onClick={validateVatNo}>
                      <EventLabel name="ValidateVatNo" groupName={"CMS.Payment"} />
                    </button>
                  )
                ) : null
              }
            />
          </>
          : null}
        {emailBool() ? <Button onClick={() => onEmail()}>Email-invoice</Button> : null}
      </>
    );
  }
});
